import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { FormProvider, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { useAuth } from 'lib/auth';

import { useAskQuestion } from '../api/askQuestion';
import { questionValidationSchema } from '../validation';
import { AttachmentsField } from './AttachmentFields';
import { InfoRow, ModalActions, textAreaSx } from './ModalActions';

export const AskQuestionModal = ({ resource, id, open, handleClose }) => {
  const { user } = useAuth();
  const methods = useForm({
    defaultValues: { question: '', files: [] },
    resolver: useYupValidationResolver(questionValidationSchema),
  });
  const { mutate: askQuestion, isPending } = useAskQuestion(resource, id, handleClose);

  const { reset, handleSubmit } = methods;
  useEffect(() => {
    if (open) reset({ question: '', files: [] });
  }, [open, reset]);

  const onSubmit = ({ question, files }) => askQuestion({ question, files });

  return (
    <Modal
      title="Ask question"
      open={open}
      handleClose={handleClose}
      sx={{ width: 560, overflowY: 'auto' }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack gap={1.5} mb={3}>
          <InfoRow
            label="Organization"
            value={user?.Company?.Name}
            note="Anonymized to suppliers"
          />
          <InfoRow
            label="User"
            value={`${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim()}
            note="Anonymized to suppliers"
          />
          <TextField
            fullWidth
            name="question"
            label="Question"
            placeholder="Please enter your question"
            multiline
            minRows={6}
            required
            sx={textAreaSx}
          />
          <AttachmentsField />
        </Stack>
        <ModalActions
          onCancel={handleClose}
          onSubmit={handleSubmit(onSubmit)}
          disabled={isPending}
        />
      </FormProvider>
    </Modal>
  );
};
